import { Typography, Button } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Plus } from '@ui/components/icons';
import { FC } from 'react';

import { VehicleMassImportDialog } from '../vehicle-mass-import-dialog/vehicle-mass-import-dialog';
import { CreateVehicleDrawer } from '../create-vehicle-drawer/create-vehicle-drawer';

export const VehiclesHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center mb-4">
      <Typography variant="h300" element="h1">
        {t('VEHICLES.TITLE')}
      </Typography>
      <div className="flex gap-4">
        <HasPermission permissionFeature="VEHICLES_ADD_VEHICLE" permissionType="WRITE">
          <CreateVehicleDrawer>
            <Button>
              <Plus />
              {t('VEHICLES.TABLE_ADD_VEHICLE')}
            </Button>
          </CreateVehicleDrawer>
        </HasPermission>

        <HasPermission permissionFeature="VEHICLES_IMPORT_VEHICLES" permissionType="WRITE">
          <VehicleMassImportDialog>
            <Button variant="secondary">{t('VEHICLES.TABLE_IMPORT_VEHICLES')}</Button>
          </VehicleMassImportDialog>
        </HasPermission>
      </div>
    </div>
  );
};
